<template>
  <div class="content-wrapper" style="min-height: 481px;">
    <section class="content-header">
      <h1>
        {{ $t('orders.title') }}
        <small>{{ $t('orders.subtitle') }}</small>
      </h1>
      <ol class="breadcrumb">
        <li><i class="fa fa-dashboard"></i> <a href="./">Dashboard</a></li>
        <li class="active">{{ $t('orders.title') }}</li>
      </ol>
    </section>

    <section class="content container-fluid">
      <div class="row">
        <div class="col-md-12">
          <div class="box box-solid">
            <div class="box-header with-border">
              <h3>{{ $t('orders.sport-program.title')}}</h3>
            </div>
            <div class="box-body">
              <div class="box-group" id="accordion1">
                <DataTable :value="sportProgramOrders" :paginator="true" :rows="20" :filters="filters">

                  <Column field="id" header="#" filterMatchMode="startsWith" :sortable="true"></Column>
                  <Column field="orderDate" header="Order Date" :sortable="true"></Column>
                  <Column field="userName" header="User Name" :sortable="true"></Column>
                  <Column field="participantName" header="Participant Name" :sortable="true"></Column>
                  <Column field="programDate" header="Program Date" :sortable="true"></Column>
                  <Column field="cost" header="Total Cost1" :sortable="true"></Column>
                </DataTable>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
  import DataTable from 'primevue/datatable';
  import Column from 'primevue/column';
  import axios from 'axios';

  import 'primevue/resources/themes/luna-blue/theme.css';
  import 'primevue/resources/primevue.min.css';
  import 'primeicons/primeicons.css';

  export default {
    name: "OrdersContent",
    props: {

    },
    data() {
      return {
        sportProgramOrders: []
      }
    },
    created(){
      let self = this;

      axios.get(
        window.host + '/sportProgramOrders')
        .then(function (response) {
          console.log(response.data);
          self.sportProgramOrders = response.data;
        })
        .catch(function (error) {
          console.log(error);
        });
    },
    methods: {
      isBackoffice: function () {
        return window.application !== 'cabinet';
      }
    },
    components:{
      DataTable,
      Column
    }
  }
</script>

<style scoped>

</style>
